/*
 * @Description: 企业管理 账户中心
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-05-24 11:05:35
 * @LastEditors: WangYuhan
 */
import { get, post, prefix } from './base';

// 创建企业及开户
export function enterpriseSubmit(params) {
  return post(`${prefix}enterprise/submit`, params);
}

// 根据卡号返回总行名称
export function getBankByCard(params) {
  return get(`${prefix}common/bank/getBankByCard`, params);
}

export function getCompany(params) {
  return get(`${prefix}enterprise/getCompany/${params.name}`, params);
}

// 企业信息 鉴权绑卡流程
export function getEnterprise(params) {
  return get(`${prefix}enterprise/getEnterprise/${params.businessId}`, params);
}

// 查询银行模糊搜索
export function findBank(params) {
  return get(`${prefix}openAccount/findBankCodeLikeName`, params);
}

// 查询代理商签署结果
// '状态 0 停用(暂停服务) 1 启用(已签约) 2 未签约 3 审核中 4 协议过期 5 审核不通过',
export function findSignResult(params) {
  return post(`${prefix}dealer/etcwx/sign/findSignResult`, params);
}

// 回填金额进行绑卡
export function bindCheckAmt(params) {
  return post(`${prefix}openAccount/bindCheckAmt`, params);
}

// 开票信息回显
export function invoiceUpdateBefore(params) {
  return get(`${prefix}corporaInvoice/updateBefore`, params);
}

// 合同列表
export function pageContract(params) {
  return get(`${prefix}contract/pageContract`, params);
}

// 邮寄信息编辑
export function invoiceMailUpdate(params) {
  return post(`${prefix}corporaInvoice/mail/update`, params);
}

// 开票信息编辑
export function invoiceUpdate(params) {
  return post(`${prefix}corporaInvoice/update`, params);
}

// 账户中心-获取企业账户信息
export function getAccountInfoByBusinessId(params) {
  return get(`${prefix}enterprise/accountInfo`, params);
}

// 绑定万金油
export function binding(params) {
  return post(`${prefix}wanjinyou/binding`, params);
}

// 解绑万金油
export function unBinding(params) {
  return deleted(`${prefix}wanjinyou/unBinding`, params);
}

// 查询万金油开通状态
export function wanjinyouval(params, val) {
  return get(`${prefix}wanjinyou/${val}`, params);
}

// 查询企业etc开通状态
export function getETCStatus(params) {
  return get(`${prefix}etcloadWaybill/getETCStatus`, params);
}

//  开通ETC
export function openEtcLoadWaybill(params) {
  return post(`${prefix}etcloadWaybill/openEtcLoadWaybill`, params);
}

// 修改ETC状态
export function updateOpenEtcLoadStatus(params) {
  return post(`${prefix}etcloadWaybill/updateOpenEtcLoadStatus`, params);
}

// 选择企业默认渠道
export function selectChannelForCorp(params) {
  return post(`${prefix}waybillSettlement/selectChannelForCorp`, params);
}
// 更新当前承运网货状态
export function updateChannelInfo(params) {
  return post(`${prefix}waybillSettlement/updateChannelInfo`, params);
}

//开通柴油账户
export function openAccount(params) {
  return get(`${prefix}wanjinyou/openAccount/${params}`);
}

// 召唤人工
export function callService(params) {
  return post(`${prefix}wxWork/callExample`, params);
}
